export default "__VITE_ASSET__DvwBF337__"